import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config-service/app-config.service';
import { AuthHttpClient } from '../auth-http-service/auth-http.service';

////-------------------------------------------------------------------------------------------
// Author:      Martin Unger
// Created:     15/05/2018
// Description: Obtains patient data from the api
////-------------------------------------------------------------------------------------------

@Injectable()
export class PatientDataService {

    constructor(private appConfigService: AppConfigService, private http: AuthHttpClient) { }

    getCurrentPregnancyId(patientId: number) {
        return this.http.get(this.appConfigService.PatientGetCurrentPregnancyId.replace('{patientId}', patientId.toString()));
    }

    getPatientId(emailAddress: string) {
        return this.http.get(this.appConfigService.PatientIdByEmailGetUrl.replace('{emailAddress}', emailAddress));
    }

    getPatient(patientId: Number) {
        return this.http.get(this.appConfigService.PatientGetUrl.replace('{patientId}', patientId.toString()));
    }

    getPreviousAppointment(pregnancyId: Number) {
        return this.http.get(this.appConfigService.PatientGetPreviousAppointmentUrl.replace('{pregnancyId}', pregnancyId.toString()));
    }

    getActivity(pregnancyId: Number) {
        return this.http.get(this.appConfigService.PatientActivityGet.replace('{pregnancyId}', pregnancyId.toString()));
    }

    getLibrary() {
        return this.http.get(this.appConfigService.PatientLibraryGet);
    }

    getQuestionnaireResult(questionnaireId: number, instanceId: number) {
        return this.http.get(this.appConfigService.PatientQuestionnaireGet.replace('{questionnaireId}',questionnaireId.toString()).replace('{instanceId}',instanceId.toString()));
    }

    getReports(pregnancyId:number)
    {
        return this.http.get(this.appConfigService.ReportsGet.replace('{pregnancyId}', pregnancyId.toString()));
    }

    getReport(reportId:number)
    {
        return this.http.get(this.appConfigService.ReportGet.replace('{reportId}', reportId.toString()));
    }

}



// WEBPACK FOOTER //
// ./src/app/services/patient-data/patient-data.service.ts